export default "__VITE_ASSET__rtfENFIh__"